if (!customElements.get('variant-bundler')) {
  customElements.define('variant-bundler',
    class VariantBundler extends HTMLElement {
      constructor() {
        super();
        this.updatePackUiElements = this.updatePackUiElements.bind(this);
      }

      connectedCallback() {
        this.config = JSON.parse(this.innerText || '{}');
        this.innerText = '';
        if (!this.config?.packs?.length) return;
        this.init();
      }

      init() {
        this.innerHTML = this.renderPackSelectors();
        this.injectHiddenMediaSlides();
        document.addEventListener('change', this.updatePackUiElements);
        this.addEventListener('change', this.handlePackSizeChange.bind(this));
        document.addEventListener('click', this.handleMultipackATCClick.bind(this));
      }

      getSelectedPack() {
        const size = this.querySelector('[name="pack-size"]:checked')?.value;
        const option = document.getElementById('color_option').innerText;
        const selectedPack = this.config.packs.find(p => {
          if (p.quantity !== Number(size)) return false;
        
          const uniqueOptions = [...new Set(p.options)];
    
          // Match single-color packs to either 'Wood' or 'Wood/Wood/Wood'
          if (uniqueOptions.length === 1) {
            return uniqueOptions[0] === option;
          }
        
          return uniqueOptions.join('/') === option;
        });      
        return selectedPack;
      }

      handlePackSizeChange(e) {
        const selectedSize = e.target.value.trim();
        this.updatePackMessage(selectedSize);
        const swatches = document.querySelectorAll('label[data-action="color-select"]');
        const selector = document.querySelector('[data-color-selector] [data-swatch-wrapper]');
        selector.querySelectorAll('[data-multicolor-swatch]').forEach(el => el.remove());

        if (Number(selectedSize) === 1) {
          swatches.forEach(label => {
            const div = label.closest('div');
            if (div) div.style.display = '';
          });

          const visible = Array.from(document.querySelectorAll(`input[name="${this.config.packs[0].optionType}"]`))
            .filter(input => input.closest('div')?.style.display !== 'none');          
          const checked = document.querySelector(`[name="${this.config.packs[0].optionType}"]:checked`);        
          if (!checked && visible.length > 0) {
            visible[0].click();
            visible[0].nextElementSibling.click();
            visible[0].checked = true;
            visible[0].setAttribute('checked', true);
          }          
          return;
        }

        const validColors = new Set(this.config.packs.filter(p => p.quantity === parseInt(selectedSize, 10) && new Set(p.options).size === 1).map(p => p.options[0]));
        swatches.forEach(label => {
          const color = label.getAttribute('title');
          const div = label.closest('div');
          if (div && validColors.has(color)) {
            div.style.display = '';
          } else {
            div.querySelector('input:checked')?.removeAttribute('checked');
            div.style.display = 'none';
          }
        });

        const multicolor = this.config.packs.filter(p => p.quantity === parseInt(selectedSize, 10) && new Set(p.options).size > 1);
        multicolor.forEach((pack, i) => {
          const deduped = [...new Set(pack.options)];
          const colorName = deduped.join('/');
          const inputId = `multicolor-pack-${i}-${selectedSize}`;

          let backgroundStyle = '';
          if (pack.swatch_url) {
            backgroundStyle = `background-image: url('${pack.swatch_url}'); background-size: cover;`;
          } else {
            const hexes = deduped
              .map(option => Array.from(swatches).find(label => label.title === option)?.style.backgroundColor)
              .filter(Boolean);

            if (hexes.length) {
              const angleStep = 360 / hexes.length;
              const stops = hexes.map((color, i) => {
                const start = i * angleStep;
                const end = start + angleStep;
                return `${color} ${start}deg ${end}deg`;
              }).join(', ');

              backgroundStyle = `background-image: conic-gradient(${stops});`;
            } else {
              backgroundStyle = 'background-color: #ccc;';
            }
          }

          const wrapper = document.createElement('div');
          wrapper.className = 'tw-flex sp-relative';
          wrapper.setAttribute('data-multicolor-swatch', '');
          wrapper.innerHTML = `
            <input type="radio" id="${inputId}" class="tw-hidden tw-peer" name="${pack.optionType}" value="${colorName}">
            <label 
              for="${inputId}" 
              class="tw-inline-flex tw-justify-center tw-items-center tw-w-16 tw-h-16 tw-rounded-full tw-cursor-pointer tw-border-0 peer-checked:tw-border-2 tw-border-solid tw-border-paka-black" 
              style="${backgroundStyle}" 
              onclick="document.querySelectorAll('[name=${pack.optionType}]').forEach(el => { el.checked = false; el.removeAttribute('checked'); }); this.checked = true; this.setAttribute('checked', 'checked'); document.getElementById('color_option').textContent = '${colorName}';"
              title="${colorName}" 
              data-action="color-select"
            >
              <span class="tw-hidden">${colorName}</span>
            </label>
          `;
          selector.appendChild(wrapper);
        });

        const visible = [...document.querySelectorAll(`div:not([style="display: none;"]) > input[name="${this.config.packs[0].optionType}"]`)];
        const checked = document.querySelector(`div:not([style="display: none;"]) > [name="${this.config.packs[0].optionType}"]:checked`);    
        if (!checked && visible.length > 0) {
          visible[0].click();
          visible[0].nextElementSibling.click();
          visible[0].checked = true;
          visible[0].setAttribute('checked', true);
        } else {
          checked.click();
          checked.nextElementSibling.click();
        }
      }

      injectHiddenMediaSlides() {
        const mediaList = document.querySelector('.product__media-list');
        const template = mediaList?.querySelector('li.product__media-item');
        if (!mediaList || !template || !Array.isArray(this.config.packs)) return;

        this.config.packs.forEach((pack, i) => {
          if (!pack.featured_image_url) return;
          const mediaId = `variant-bundler-hidden-pack-${i}`;
          const clone = template.cloneNode(true);
          clone.classList.add('injected-pack-image', 'slider-image-hidden');
          clone.setAttribute('data-media-id', mediaId);

          const img = clone.querySelector('modal-opener img');
          if (img) {
            img.src = pack.featured_image_url;
            img.setAttribute('data-media-id', mediaId);
            img.alt = `Pack Preview Image ${i + 1}`;
            img.removeAttribute('srcset');
          }

          const noscriptImg = clone.querySelector('noscript img');
          if (noscriptImg) {
            noscriptImg.src = pack.featured_image_url;
            noscriptImg.alt = `Pack Preview Image ${i + 1}`;
            noscriptImg.removeAttribute('srcset');
          }

          const button = clone.querySelector('.product__media-toggle');
          if (button) {
            button.setAttribute('data-media-id', mediaId);
            const span = button.querySelector('.visually-hidden');
            if (span) span.textContent = `Open pack preview ${i + 1} in gallery view`;
          }

          const modalOpener = clone.querySelector('modal-opener');
          if (modalOpener) {
            modalOpener.setAttribute('data-modal', '#ProductModal-template--16854111027284__main');
          }

          mediaList.appendChild(clone);
        });
      }

      updatePackUiElements(e) {
        this.updateVariantAvailability();
        this.updateMultipackATCButton();

        const mediaList = document.querySelector('.product__media-list');
        if (!mediaList || !this.getSelectedPack()) return;

        document.querySelectorAll('.injected-pack-image').forEach(el => {
          el.classList.add('slider-image-hidden');
          mediaList.appendChild(el);
        });

        if (this.getSelectedPack().featured_image_url) {
          const imageLi = Array.from(document.querySelectorAll('.injected-pack-image')).find(li => li.querySelector(`img[src="${this.getSelectedPack().featured_image_url}"]`));
          if (imageLi) {
            imageLi.classList.remove('slider-image-hidden');
            mediaList.prepend(imageLi);
          }
        }

        const savingsEls = document.querySelectorAll('[data-savings-calculation]');
        savingsEls.forEach(savingsEl => {
          if (savingsEl) {
            if (this.getSelectedPack().quantity > 1 && this.config.full_product_price) {
              const full = Number(this.config.full_product_price);
              const retail = full * this.getSelectedPack().quantity;
              const discount = Math.round((1 - this.getSelectedPack().price / retail) * 100);
              if (discount > 0) {
                savingsEl.innerText = `Buy ${this.getSelectedPack().quantity} Save ${discount}%`;
                savingsEl.classList.remove('sp-hidden', 'empty');
              } else {
                savingsEl.innerText = '';
                savingsEl.classList.add('sp-hidden');
              }
            } else {
              savingsEl.innerText = '';
              savingsEl.classList.add('sp-hidden');
            }
          }
        });
        
        const priceRoots = document.querySelectorAll('[data-price-renderer]');
        priceRoots.forEach(priceRoot => {
          if (priceRoot) {
            priceRoot.closest('.visibility-hidden')?.classList.remove('visibility-hidden');
            priceRoot.classList.add('price--on-sale');
            const format = val => `$${val.toFixed(2).replace(/\.00$/, '').replace(/(\.\d)0$/, '$1')}`;
            const full = Number(this.config.full_product_price);
            const retail = format(full * this.getSelectedPack().quantity);
            const bundle = format(this.getSelectedPack().price);
            priceRoot.innerHTML = `
              <dl class="tw-m-0">
                <div class="price__sale">
                  <dt class="price__compare">
                    <span class="visually-hidden visually-hidden--inline">Regular price</span>
                  </dt>
                  <dd class="price__compare tw-ml-2 tw-opacity-75">
                    <s class="price-item price-item--regular">${retail}</s>
                  </dd>
                  <dt>
                    <span class="visually-hidden visually-hidden--inline">Sale price</span>
                  </dt>
                  <dd class="price-tag tw-ml-2">
                    <span class="price-item price-item--sale">${bundle}</span>
                  </dd>
                </div>
              </dl>
            `;
          } 
        });        
      }

      parsePackMessages() {
        const raw = this.config.pack_size_messages;
        if (!raw) return {};
        return raw.split('//').reduce((acc, segment) => {
          const idx = segment.indexOf(':');
          if (idx === -1) return acc;
          const qty = parseInt(segment.slice(0, idx).trim(), 10);
          const msg = segment.slice(idx + 1).trim();
          if (!isNaN(qty) && msg) acc[qty] = msg;
          return acc;
        }, {});
      }

      updatePackMessage(size) {
        const el = this.querySelector('[data-pack-message]');
        if (!el) return;
        const messages = this.parsePackMessages();
        const msg = messages[Number(size)];
        if (msg) {
          el.textContent = msg;
          el.classList.remove('sp-hidden');
        } else {
          el.textContent = '';
          el.classList.add('sp-hidden');
        }
      }

      renderPackSelectors() {
        const packs = this.config.packs || [];
        const full = Number(this.config.full_product_price);
        const hasMulti = packs.some(p => p.quantity > 1);
        if (!hasMulti) return '';

        const multiQuantities = [...new Set(packs.map(p => p.quantity).filter(q => q > 1))].sort((a, b) => a - b);
        const quantities = [1, ...multiQuantities];
        const messages = this.parsePackMessages();
        const initialMessage = messages[1] ?? '';

        return `
          <fieldset class="sp-border-0 sp-pt-[15px] sp-pb-0 sp-px-0 sp-m-0 sp-border-t tw-border-gray-200 sp-flex sp-flex-wrap sp-gap-[10px]">
            ${quantities.map(quantity => {
              const isSingle = quantity === 1;
              const pack = packs.find(p => p.quantity === quantity);
              let discountHTML = '';
              if (!isSingle && pack && full) {
                const retail = full * pack.quantity;
                const discount = Math.round((1 - pack.price / retail) * 100);
                if (discount > 0) {
                  discountHTML = `<span class="sp-absolute sp-top-0 sp-right-0 sp-font-bold sp-text-pakaBlack sp-text-[10px] sp-leading-none sp-tracking-[-0.1px] sp-transform -sp-translate-y-1/2 sp-block sp-bg-[#D1DFDA] sp-rounded-[18px] sp-py-[3px] sp-px-[5px]">Save ${discount}%</span>`;
                }
              }
              return `
                <label class="sp-block sp-py-[12px] sp-px-[28px] sp-border-2 sp-border-solid sp-border-pakaBlack sp-rounded-[33px] sp-text-[16px] sp-font-bold sp-relative sp-leading-[12px] sp-tracking-[-0.127px] sp-text-[#212329CC] sp-transition has-[:checked]:sp-bg-pakaBlack has-[:checked]:sp-text-white">
                  <input ${isSingle ? 'checked' : ''} type="radio" name="pack-size" class="sp-absolute sp-top-0 sp-left-0 sp-w-full sp-h-full sp-opacity-0 sp-m-0 sp-border-0 sp-p-0 sp-cursor-pointer" value="${quantity}" />
                  ${isSingle ? 'Single' : `${quantity}-pack`}
                  ${discountHTML}
                </label>
              `;
            }).join('')}
          </fieldset>
          <div data-pack-message class="sp-m-0 sp-font-medium sp-pt-5 sp-text-[14px] sp-text-[#af5443]${initialMessage ? '' : ' sp-hidden'}">${initialMessage}</div>
        `;
      }
      
      updateVariantAvailability() { 
        const inputs = document.querySelectorAll('variant-radios input[name]:not([data-color-input]):not([name="Color"])');
        const variantData = document.querySelector('variant-radios')?.getVariantData();
        const prodOptionIndex = Number(this.config.option_index) - 1;

        if (!this.getSelectedPack()) {
          const color = document.querySelector('[data-option-color]:checked')?.value;

          if (color) {
            inputs.forEach((input) => {
              const inputName = input.name;
          
              const allOptionNames = Array.from(document.querySelectorAll('variant-radios input[name]'))
                .map(input => input.name)
                .filter((name, idx, arr) => arr.indexOf(name) === idx);

              const optionIndex = allOptionNames.indexOf(inputName);          
              if (optionIndex === -1) return;

              const available = variantData.some(variant =>
                variant.options[prodOptionIndex] === color &&
                variant.options[optionIndex] === input.value &&
                variant.available
              );
          
              if (available) {
                input.parentNode.classList.remove("tw-opacity-50", "option-unavailable");
              } else {
                input.parentNode.classList.add("tw-opacity-50", "option-unavailable");
              }
            });
          }
          return;    
        }
        
        const selectedPack = this.getSelectedPack();
        const selectedColors = [... new Set(selectedPack.options)];   
        if (prodOptionIndex === false || !Array.isArray(selectedColors) || selectedColors.length === 0) return;
                            
        inputs.forEach((input) => {
          const inputName = input.name;
      
          const allOptionNames = Array.from(document.querySelectorAll('variant-radios input[name]'))
            .map(input => input.name)
            .filter((name, idx, arr) => arr.indexOf(name) === idx);

          const optionIndex = allOptionNames.indexOf(inputName);          
          if (optionIndex === -1) return;
                
          const colorCounts = selectedPack.options.reduce((acc, color) => {
            acc[color] = (acc[color] || 0) + 1;
            return acc;
          }, {});

          const isAvailableForAllColors = selectedColors.every(color => {
            const requiredQty = colorCounts[color] || 1;

            return variantData.some(variant =>
              variant.options[prodOptionIndex] === color &&
              variant.options[optionIndex] === input.value &&
              variant.available &&
              variant.inventory_quantity >= requiredQty
            );
          });
      
          if (isAvailableForAllColors) {
            input.parentNode.classList.remove("tw-opacity-50", "option-unavailable");
          } else {
            input.parentNode.classList.add("tw-opacity-50", "option-unavailable");
          }
        });
      }
      
      updateMultipackATCButton() {
        const buyBlock = document.querySelector('.buy-buttons-block');
        if (!buyBlock) return;
      
        const selectedPack = this.getSelectedPack();
        const existingBtn = buyBlock.querySelector('[data-multipack-atc]');
              
        if (!selectedPack || selectedPack.quantity === 1) {
          existingBtn?.remove();
          return;
        }
      
        const btn = existingBtn || document.createElement('button');
        btn.setAttribute('data-multipack-atc', '');
        btn.className = 'product-form__submit button button--full-width button--secondary';
        
        const allOptionsSelected = [...document.querySelectorAll('variant-radios fieldset')].every(fieldset => fieldset.querySelector('input:checked'));
        const unavailableSelected = Array.from(document.querySelectorAll('.option-unavailable input:checked')).length > 0;
        const unavailableFieldset = document.querySelector('variant-radios fieldset:not(:has(div:not(.option-unavailable)))');
                
        if (!allOptionsSelected && !unavailableFieldset) {
          btn.textContent = 'Select a size';
          btn.disabled = true;
          btn.classList.remove('tw-opacity-50');
          btn.classList.add('!sp-opacity-100');
        } else if (unavailableSelected || unavailableFieldset) {
          btn.textContent = 'Unavailable';
          btn.disabled = true;
          btn.classList.add('tw-opacity-50');
          btn.classList.remove('!sp-opacity-100');
        } else {
          btn.textContent = 'Add to cart';
          btn.disabled = false;
          btn.classList.remove('tw-opacity-50');
        }
        
        btn.insertAdjacentHTML(
          'beforeend', 
          `<div class="loading-overlay__spinner hidden">
            <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
              <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
            </svg>
          </div>`
        );
      
        if (!existingBtn) {
          buyBlock.appendChild(btn);
        }
      }
      
      async handleMultipackATCClick(e) {
        const btn = e.target.closest('[data-multipack-atc]');
        const selectedPack = this.getSelectedPack();
        const variantData = document.querySelector('variant-radios')?.getVariantData?.();
              
        if (!btn || btn.disabled || !selectedPack || !variantData) return;
        btn.classList.add('loading');
        btn.setAttribute('aria-disabled', true);
        btn.querySelector('.loading-overlay__spinner').classList.remove('hidden');
        btn.querySelector('.loading-overlay__spinner').style.display = 'flex';
      
        const bundleId = crypto.randomUUID();
        const adjustedOptionIndex = this.config.option_index - 1;
      
        const selectedOptions = [...document.querySelectorAll('variant-radios fieldset')]
          .map(fs => fs.querySelector('input:checked')?.value)
          .filter(Boolean);
        selectedOptions.splice(adjustedOptionIndex, 1);
      
        const items = [];
      
        for (const option of selectedPack.options) {
          for (const variant of variantData) {
            if (
              variant.options[adjustedOptionIndex] === option &&
              selectedOptions.every(opt => variant.options.includes(opt))
            ) {
              items.push({
                id: variant.id,
                quantity: 1,
                properties: {
                  _bundle: `${this.config.product_name} / ${selectedPack.options.join(', ')} / ${selectedPack.quantity}-pack`,
                  _bundle_id: bundleId,
                  _bundle_option: variant.options[adjustedOptionIndex]
                }
              });
            }
          }
        }
      
        if (items.length) {
          document.dispatchEvent(new CustomEvent('multi_pack_add', { detail: items }));
        }
        
        setTimeout(() => {
          btn.classList.remove('loading');
          btn.removeAttribute('aria-disabled', true);
          btn.querySelector('.loading-overlay__spinner').classList.add('hidden');
        }, 5000);
      }
           
    }
  )
}
